import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const SimpleLoading : React.FC<{}> = () => <FontAwesomeIcon icon={faSpinner} size="3x" spin />

export default SimpleLoading;